import React from 'react';
import { FilterOption } from '@/components/ui/FilterDropdown';
import { 
  DescriptionField, 
  FilterTabs 
} from '@/components/image-generator/FilterBar/components';
import AudioSelector from './components/AudioSelector';
import styles from '@/components/image-generator/FilterBar/FilterBar.module.css';

interface VideoFilterBarProps {
  hasAudio: boolean;
  onAudioChange: (hasAudio: boolean) => void;
  styleOptions: FilterOption[];
  selectedStyle: string | null;
  onStyleChange: (options: FilterOption[]) => void;
  setSelectedStyle: (style: string | null) => void;
  influenceOptions: FilterOption[];
  selectedInfluence: string | null;
  onInfluenceChange: (options: FilterOption[]) => void;
  setSelectedInfluence: (influence: string | null) => void;
  colorOptions: FilterOption[];
  onColorChange: (options: FilterOption[]) => void;
  backgroundOptions: FilterOption[];
  onBackgroundChange: (options: FilterOption[]) => void;
  selectedBackground: string | null;
  environmentOptions: FilterOption[];
  onEnvironmentChange: (options: FilterOption[]) => void;
  moodOptions: FilterOption[];
  onMoodChange: (options: FilterOption[]) => void;
  videoDescription: string;
  onVideoDescriptionChange: (value: string) => void;
}

const VideoFilterBar: React.FC<VideoFilterBarProps> = React.memo(({
  hasAudio,
  onAudioChange,
  styleOptions,
  selectedStyle,
  onStyleChange,
  setSelectedStyle,
  influenceOptions,
  selectedInfluence,
  onInfluenceChange,
  setSelectedInfluence,
  colorOptions,
  onColorChange,
  backgroundOptions,
  onBackgroundChange,
  selectedBackground,
  environmentOptions,
  onEnvironmentChange,
  moodOptions,
  onMoodChange,
  videoDescription,
  onVideoDescriptionChange
}) => {
  return (
    <div className="space-y-6">
        {/* Video Prompt Field - Moved to the top */}
        <div className="w-full">
          <DescriptionField 
            imageDescription={videoDescription} 
            onImageDescriptionChange={onVideoDescriptionChange}
          />
        </div>
        
        <div>
          {/* Audio Selection Header */}
          <div className="mb-3">
            <h3 className="text-sm font-medium mb-1 text-purple-600 dark:text-purple-400">Audio</h3>
          </div>
          
          {/* Audio Selection */}
          <AudioSelector 
            hasAudio={hasAudio} 
            onAudioChange={onAudioChange} 
          />
        </div>

        {/* Style Filters - same as image generator */}
        <div className={`${styles.filterCard}`}>
          <FilterTabs 
            styleOptions={styleOptions}
            selectedStyle={selectedStyle}
            onStyleChange={onStyleChange}
            setSelectedStyle={setSelectedStyle}
            influenceOptions={influenceOptions}
            selectedInfluence={selectedInfluence}
            onInfluenceChange={onInfluenceChange}
            setSelectedInfluence={setSelectedInfluence}
            colorOptions={colorOptions}
            onColorChange={onColorChange}
            backgroundOptions={backgroundOptions}
            onBackgroundChange={onBackgroundChange}
            selectedBackground={selectedBackground}
            environmentOptions={environmentOptions}
            onEnvironmentChange={onEnvironmentChange}
            moodOptions={moodOptions}
            onMoodChange={onMoodChange}
          />
        </div>
    </div>
  );
});

VideoFilterBar.displayName = 'VideoFilterBar';

export default VideoFilterBar; 